import axios from "axios";
import { BASE_URL } from "../../variables";
import { getUniqueListBy } from "@components/Common/Function";

export const getWssCountApi = async (data, filterValue) => {
    let TTYCodes = [];
    if (data?.length > 0) {
        const TTYCodeData = getUniqueListBy(data, "SH2_Code__c");
        TTYCodeData?.forEach((item) => {
            TTYCodes.push(item?.SH2_Code__c);
        });
        const options = {
            url: `${BASE_URL}/services/apexrest/wssListResponse`,
            method: "post",
            data: {
                territoryCodes: TTYCodes,
                month: filterValue
            },
        };
        try {
            const response = await axios(options);
            if (response.status === 200) {
                return {
                    success: true,
                    data: response?.data,
                };
            } else {
                throw Error("Something Went Wrong..!!");
            }
        } catch (err) {
            console.log(err);
            return {
                success: false,
                msg: "Somthing Went Wrong..!!",
            };
        }
    } else {
        return {
            success: true,
            data: { records: [] },
        };
    }
};
